/* ============================================================
   HHM Theme — Core JS
   Mobile nav, FAQ accordions, header scroll
   ============================================================ */

(function() {
  'use strict';

  // ---- Mobile nav ----
  const menuBtn   = document.querySelector('[data-mobile-menu-trigger]');
  const mobileNav = document.getElementById('HHMMobileNav');
  const navLinks  = document.querySelectorAll('[data-mobile-nav-link]');

  function getFocusable() {
    return Array.from(mobileNav.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])'));
  }

  function trapFocus(e) {
    if (e.key === 'Escape') { closeNav(); return; }
    if (e.key !== 'Tab') return;
    const focusable = getFocusable();
    if (!focusable.length) return;
    const first = focusable[0];
    const last  = focusable[focusable.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  function openNav() {
    mobileNav.classList.add('is-open');
    menuBtn.setAttribute('aria-expanded', 'true');
    mobileNav.setAttribute('aria-hidden', 'false');
    document.body.classList.add('hhm-nav-open');
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', trapFocus);
    const first = getFocusable()[0];
    if (first) first.focus();
  }

  function closeNav() {
    mobileNav.classList.remove('is-open');
    menuBtn.setAttribute('aria-expanded', 'false');
    mobileNav.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('hhm-nav-open');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', trapFocus);
    menuBtn.focus();
  }

  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', () => {
      mobileNav.classList.contains('is-open') ? closeNav() : openNav();
    });
    navLinks.forEach(link => link.addEventListener('click', closeNav));
  }

  // ---- FAQ details accordion (native <details>) ----
  // Allows only one open at a time
  document.querySelectorAll('.hhm-faq-item').forEach(item => {
    item.addEventListener('toggle', function() {
      if (this.open) {
        document.querySelectorAll('.hhm-faq-item[open]').forEach(other => {
          if (other !== this) other.removeAttribute('open');
        });
      }
    });
  });

  // ---- Ingredients accordion ----
  document.querySelectorAll('.hhm-ingredients-category__header').forEach(header => {
    header.addEventListener('click', () => {
      const cat = header.closest('.hhm-ingredients-category');
      const isOpen = cat.classList.toggle('is-open');
      header.setAttribute('aria-expanded', String(isOpen));
    });
  });

  // ---- Header shadow on scroll ----
  const header = document.getElementById('HHMHeader');
  if (header) {
    window.addEventListener('scroll', () => {
      header.style.boxShadow = window.scrollY > 0 ? '0 2px 20px rgba(0,0,0,0.06)' : '';
    }, { passive: true });
  }

})();
